import React, { useState, useEffect, useCallback } from "react";
import useStyles from "./style";
import {
  Dialog,
  DialogContent,
  Typography,
  Button,
  Grid,
  TextField,
  Box,
} from "@mui/material";
import { EditOutlined } from "@mui/icons-material";
import _ from "lodash";
import { useFormik } from "formik";
import * as yup from "yup";

//Libs
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import { useDispatch } from "react-redux";

//Services
import AvailablebanksApi from "Services/Availablebanks";

const Bankupdate = (props) => {
  const { openDialog, id, handleClose } = props;
  const classes = useStyles();
  const dispatch = useDispatch();
  const [details, setDetails] = useState([]);

  // Fetch Account Type Details
  const getDetails = useCallback(() => {
    dispatch(showLoader("Loading please wait..."));
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        setDetails(res?.data?.data);
      } else {
        setDetails(null);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
    };
    if (id) {
      AvailablebanksApi.getBankDetailsbyIdacc(id).then(onSuccess, onFailure);
    }
  }, [id, dispatch]);

  useEffect(() => {
    if (openDialog) {
      getDetails();
    }
  }, [openDialog, getDetails]);

  const handleUpdateBank = (formValues) => {
    dispatch(showLoader("Loading please wait..."));

    const data = {
      accounttype: formValues?.accounttype,
      Cashoutcode: formValues?.Cashoutcode,
    };

    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        dispatch(
          showSnackbar({
            message: "Bank Account types Updated Successfully",
            autoHideDuration: 3000,
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
            variant: "success",
          })
        );
        formik.resetForm();
        handleClose();
      }
    };

    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Error while update",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
    };

    AvailablebanksApi.updateBankacc(id, { ...data }).then(onSuccess, onFailure);
  };

  useEffect(() => {
    if (!_.isEmpty(details)) {
      formik.setFieldValue("accounttype", details?.accounttype || "");
      formik.setFieldValue("Cashoutcode", details?.Cashoutcode || "");
    }
  }, [details]);

  const formik = useFormik({
    initialValues: {
      accounttype: "",
      Cashoutcode: "",
    },
    validationSchema: yup.object({
      accounttype: yup.string().required("Account type is required").nullable(),
      Cashoutcode: yup
        .number()
        .typeError("Cashoutcode must be a number")
        .required("Cashoutcode is required")
        .nullable(),
    }),
    enableReinitialize: true,
    onSubmit: handleUpdateBank,
  });

  return (
    <Dialog
      open={openDialog}
      onClose={() => {
        formik.resetForm();
        handleClose();
      }}
      classes={{ paper: classes.dialogPaper }}
    >
      <Box className={classes.headerContainer}>
        <Typography className={classes.dialogTitle}>Update Bank Account type</Typography>
        <Typography className={classes.breadcrumb}>
          Admin / <span>Account Type Settings</span>
        </Typography>
      </Box>

      <DialogContent style={{ padding: 0 }}>
        <form onSubmit={formik.handleSubmit}>
          <Grid container spacing={3}>
            {/* Account Type */}
            <Grid item xs={12} md={6}>
              <Typography className={classes.formLabel}>Account Type</Typography>
              <TextField
                name="accounttype"
                placeholder="e.g. Savings"
                value={formik.values.accounttype}
                onChange={formik.handleChange}
                error={formik.touched.accounttype && Boolean(formik.errors.accounttype)}
                helperText={formik.touched.accounttype && formik.errors.accounttype}
                fullWidth
                variant="outlined"
                size="small"
                className={classes.formInput}
              />
            </Grid>

            {/* Code */}
            <Grid item xs={12} md={6}>
              <Typography className={classes.formLabel}>Code</Typography>
              <TextField
                name="Cashoutcode"
                placeholder="e.g. 101"
                value={formik.values.Cashoutcode}
                onChange={formik.handleChange}
                error={formik.touched.Cashoutcode && Boolean(formik.errors.Cashoutcode)}
                helperText={formik.touched.Cashoutcode && formik.errors.Cashoutcode}
                fullWidth
                variant="outlined"
                size="small"
                className={classes.formInput}
              />
            </Grid>
          </Grid>

          <Box className={classes.dialogActions}>
            <Button
              className={classes.cancelButton}
              onClick={() => {
                formik.resetForm();
                handleClose();
              }}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              variant="contained"
              className={classes.submitButton}
            >
              <EditOutlined style={{ fontSize: "18px" }} />
              Save Changes
            </Button>
          </Box>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default Bankupdate;
